'use client'

import React from 'react'
import useMarketo from '../../lib/useMarketo'
import './MarketoForm.css'

function MarketoForm(props: { formId: string, baseURL: string, munchkinId: string }) {
    useMarketo({ formId: props.formId, baseURL: props.baseURL, munchkinId: props.munchkinId, callback: () => {}, });
    return <form id={`mktoForm_${props.formId}`} aria-hidden='true' />;
};

export default MarketoForm;